import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import FeaturedArticles from './components/FeaturedArticles';
import CategoryGrid from './components/CategoryGrid';
import SafetyHighlight from './components/SafetyHighlight';
import FAQSection from './components/FAQSection';

const faqItems = [
  {
    q: '捆绑调教安全吗？',
    a: '当遵循正确的安全守则、使用合适的道具、并在充分沟通和自愿的前提下进行时，捆绑调教是相对安全的。但任何BDSM活动都存在一定风险，这也是为什么安全教育如此重要。我们强烈建议所有初学者从安全须知开始学习，并始终以SSC原则（安全、理性、自愿）为指导。',
  },
  {
    q: '初学者应该从什么道具开始准备？',
    a: '初学者建议从棉绳或处理好的麻绳（直径6mm）入手，配上一把EMT急救剪刀是基本配置。后续可以根据需求逐步添置眼罩、软垫等辅助道具。不建议一开始就购买大量专业设备，循序渐进是最好的方式。',
  },
  {
    q: '如何与伴侣沟通捆绑调教的意愿？',
    a: '建议在轻松、私密的环境中进行坦诚的沟通。可以从分享相关文章或视频开始，了解彼此的感受和边界。重要的是强调这是双方的共同探索，任何一方都有随时说不的权利。使用开放式表达，避免施加压力。',
  },
  {
    q: '如何选择合适的绳索材质？',
    a: '棉绳柔软亲肤，适合初学者和追求舒适度的场景；麻绳摩擦力好、结扣牢固，是传统日式绳缚的首选，但需要一定的保养；合成纤维绳（如尼龙）强度高但摩擦灼伤风险较大。建议从棉绳或处理好的麻绳开始尝试，找到最适合自己的材质。',
  },
  {
    q: '捆绑后出现绳索痕迹正常吗？',
    a: '轻微的绳索压痕是正常的，通常会在几小时到一天内消退。如果出现持续红肿、淤青或疼痛，说明捆绑过紧或压迫了神经，需要引起重视。为了减少痕迹，可以在绳索下方使用护套，并确保绳索不会过紧。',
  },
  {
    q: '什么是安全词？如何设定？',
    a: '安全词是一个事先约定好的词语或信号，当被缚者说出或做出这个信号时，所有活动必须立即停止。推荐使用红黄绿系统：红色代表立即停止一切活动，黄色代表放慢或调整当前操作，绿色代表一切正常继续。',
  },
];

export default function Home() {
  return (
    <>
      <SEOHead
        title="捆绑调教完全指南"
        description="捆绑调教完全指南提供系统性内容，涵盖安全须知、道具选择、基础到进阶技巧，以及双方信任建立与事后关怀，帮助成人伴侣在安全、自愿、理性的前提下探索捆绑调教的乐趣与边界。"
        keywords="捆绑调教,捆绑调教技巧,捆绑调教道具,捆绑调教安全须知,捆绑调教入门教程,成人捆绑玩法,BDSM捆绑指南"
        canonicalUrl="/"
        jsonLdScripts={[
          {
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '捆绑调教完全指南',
            url: 'https://bondage-guide.com',
            description: '围绕捆绑调教提供系统性内容，涵盖安全须知、道具选择、基础到进阶技巧，以及双方信任建立与事后关怀。',
            inLanguage: 'zh-CN',
          },
          {
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '捆绑调教完全指南',
            url: 'https://bondage-guide.com',
            description: '成人伴侣捆绑调教教育平台',
          },
          {
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '捆绑调教完全指南 - 首页',
            description: '捆绑调教完全指南提供系统性内容，涵盖安全须知、道具选择、基础到进阶技巧。',
            isPartOf: { '@type': 'WebSite', name: '捆绑调教完全指南', url: 'https://bondage-guide.com' },
          },
          {
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqItems.map((item) => ({
              '@type': 'Question',
              name: item.q,
              acceptedAnswer: {
                '@type': 'Answer',
                text: item.a,
              },
            })),
          },
        ]}
      />
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedArticles />
        <CategoryGrid />
        <SafetyHighlight />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}